import React from 'react';
import { Nav, Tab } from 'react-bootstrap';
import './Tabs.scss';
interface TabProps {
    key: string;
    title: string;
    children: React.ReactNode;
}
interface StakeTabsProps {
    tabs: TabProps[];
    activeKey: string;
    onTabChange: (key: string | null) => void;
}
const StakeTabs: React.FC<StakeTabsProps> = ({ tabs, activeKey, onTabChange }) => {
    return (
        <div className="staketabs">
            <Tab.Container unmountOnExit
                id="staketabs"
                activeKey={activeKey}
                onSelect={(eventKey: string | null) => {
                    if (eventKey !== null) {
                        onTabChange(eventKey);
                    }
                }}
                transition={true}
            >
                <Nav>
                    {tabs.map((tab) => (
                        <Nav.Item key={tab.key}>
                            <Nav.Link eventKey={tab.key}>{tab.title}</Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>
                <Tab.Content>
                    {tabs.map((tab) => (
                        <Tab.Pane eventKey={tab.key} key={tab.key} transition={true}>
                            {tab.children}
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};
export default StakeTabs;
